<template>
  <div>
    <list row-key="UserId" ref="list" unit="晚休统计" :page="page" :query-params="params"
      :show-checkbox="false" :show-query="showQuery" :get-data-func="api.getStatList">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" size="mini" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" size="mini" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input size="mini" v-model="params.FullName" placeholder="请填写姓名" clearable />
        </el-form-item>
        <el-form-item label="宿舍号">
          <el-input size="mini" v-model="params.Dormitory" placeholder="请填写宿舍号" clearable />
        </el-form-item>
        <el-form-item label="本学期留宿次数" class="longLabel">
          <el-input size="mini" v-model="params.TermCount" type="number" placeholder="请填写次数" oninput="value=value.replace(/[^\d]/g,'')" clearable />
        </el-form-item>
        <el-form-item label="过去一个月留宿次数" class="largeLabel">
          <el-input size="mini" v-model="params.MonthCount" type="number" placeholder="请填写次数" oninput="value=value.replace(/[^\d]/g,'')" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="Class" label="班级" min-width="90" />
        <el-table-column prop="FullName" label="姓名"/>
        <el-table-column prop="Sex" label="性别">
          <template slot-scope="{row}">
            <span v-if="row.Sex==1">男</span>
            <span v-else-if="row.Sex==2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="Dormitory" label="宿舍号" />
        <el-table-column prop="TermCount" label="本学期留宿次数" />
        <el-table-column prop="MonthCount" label="过去一个月留宿次数" />
      </template>
    </list>
  </div>
</template>
<script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";

  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
        api: require("@/api/attendance/reg").default,
        grade_api: require("@/api/ed/grade").default,
        class_api: require("@/api/ed/class").default,
        termApi: require("@/api/ed/term").default,
        params: {
          FullName: "",
          Dormitory: "",
          TermId: null,
          GradeId: null,
          ClassId: null,
          TermCount: null,
          MonthCount: null,
        },
        isMB: this.$store.state.isMB,
        termList: [],
        grades: [],
        classes: [],
      };
    },
    beforeMount() {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      this.params.TermId = loginInfo.TermId;
      this.termApi.list().then((res) => {
        if (res.Data && res.Data.length > 0) {
          this.termList = res.Data;
          if (!this.params.TermId) {
            this.params.TermId = res.Data[0].TermId;
          }
          this.$refs.list.initQueryParams.TermId = this.params.TermId;
          this.query({ TermId: this.params.TermId });
        }
      });
      this.getGrade();
    },
    methods: {
      onExport() {
        this.api.exportStatList(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
      },
      termChange(e) {
        this.params.ClassId = null;
        this.getClass();
        this.getGrade();
        this.query({ TermId: e });
      },
      getGrade() {
        this.grade_api.list().then((res) => {
          this.grades = res.Data;
        });
      },
      getClass() {
        this.params.ClassId = null;
        if (!this.params.GradeId) {
          this.classes = [];
          return;
        }
        var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
        this.class_api.list(params).then((res) => {
          this.classes = res.Data;
        });
      },
    },
  };
</script>
<style lang="scss">
</style>